import { useEffect, useState } from "react"
import { assemblyAPIs } from "../../apis/assembly";
import { Row, RowHeader, RowsContainer, DataGrid, DeleteIcon, EditIcon, SaveIcon } from "../../components";
import { DeleteForm } from "../../components/DeleteForm/DeleteForm";
import { HeaderItem, RowItem } from "../../components/RowsContainer";
import { actions } from "../../store";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { AssemblyState } from "../../store/reducers/assemblyReducer";

export const SubAssembly = (props: {
    index: number,
    colorInd: number,
}) => {
    const state = useAppSelector((state: any): AssemblyState => state.assembly);
    const { common } = actions;
    let initialSubAsmObj = state.assemblies[state.selectedIndex].subAssemblies ?
        JSON.parse(JSON.stringify(state.assemblies[state.selectedIndex].subAssemblies[props.index])) : {};
    const [updateObj, setUpdateObj] = useState(state.assemblies[state.selectedIndex]);
    const [subAsmObj, setPartObj] = useState(initialSubAsmObj);
    const dispatch = useAppDispatch();
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const handleChange = (e: any) => {
        setPartObj({
            ...subAsmObj,
            quantity: parseFloat(e.target.value)
        })
    }

    useEffect(() => {
        let initialSubAsmObj = state.assemblies[state.selectedIndex].subAssemblies ?
        JSON.parse(JSON.stringify(state.assemblies[state.selectedIndex].subAssemblies[props.index])) : {};
        setPartObj(initialSubAsmObj);
    }, [props.index])

    const handleSave = async () => {
        let assemblyObj = JSON.parse(JSON.stringify(state.assemblies[state.selectedIndex]));
        assemblyObj.subAssemblies[props.index] = {...subAsmObj};
        await assemblyAPIs.updateAssembly(assemblyObj, assemblyObj._id);
        setShowEdit(false);
        dispatch(common.setFlyMsg({msg: `Updated quantity for the sub assembly "${subAsmObj.partName}" in assembly "${assemblyObj.name}"`}));    
    }

    const handleDelete = () => {
        let assemblyObj = JSON.parse(JSON.stringify(state.assemblies[state.selectedIndex]));
        assemblyObj.subAssemblies.splice(props.index);
        setUpdateObj(assemblyObj);
        setShowDelete(true);
    }

    return <><Row key={subAsmObj.name} color={props.index%2 === 0 ? false : true}>
        <RowItem width={10} value={`${props.colorInd+1}`}></RowItem>
        <RowItem width={20} value={subAsmObj.assemblyName}></RowItem>
        <RowItem width={20} value={subAsmObj.assemblyType}></RowItem>
        {!showEdit ? <RowItem width={40} value={`${subAsmObj.quantity} pc`}></RowItem> :
            <RowItem width={40}>
                <input type="number" onChange={handleChange} defaultValue={subAsmObj.quantity}></input>
                <span>pc</span>
            </RowItem>}
        <RowItem width={10}>
            { !showEdit ? 
                [<DeleteIcon onClick={handleDelete}></DeleteIcon>,
                <EditIcon onClick={() => {setShowEdit(true)}} ></EditIcon>]:
                    <SaveIcon onClick={handleSave}></SaveIcon>}
        </RowItem>
    </Row>
    {showDelete? <DeleteForm
        icon="AssemblyActive"
        showModal={showDelete}
        closeFn={() => {setShowDelete(false)}}
        name="Sub Assembly"
        value={subAsmObj.assemblyName}
        payload={updateObj}
        deleteFn={assemblyAPIs.updateAssembly}
        ></DeleteForm> : <></>
    }
    </>
}


export const SubAssemblysHeader = () => {
    return <RowHeader height="20%">
        <HeaderItem key="heading-s-no" width={10} value="S.No"></HeaderItem>
        <HeaderItem key="heading-name" width={20} value="Assembly Name"></HeaderItem>
        <HeaderItem key="heading-type" width={20} value="Assembly Type"></HeaderItem>
        <HeaderItem key="heading-quantity" width={40} value="Quantity"></HeaderItem>
        <HeaderItem key="heading-action" width={10} value="Action"></HeaderItem>
    </RowHeader>
}

export const SubAssembliesDataGrid = () => {
    const state = useAppSelector((state: any): AssemblyState => state.assembly);

    const searchPassSubAsm = (asm: any) => {
        let text = state.subAsmSearchText.toLowerCase();
        let include = asm.assemblyName.toLowerCase().includes(text) || asm.assemblyNumber.toLowerCase().includes(text)
            || asm.quantity.toString().toLowerCase().includes(text)
        return include;
    }

    const getData = () => {
        if (state.assemblies.length === 0) {
            return <RowsContainer></RowsContainer>
        }
        let parts = [];
        let ind  = 0;
        for (let i = 0; i < state.assemblies[state.selectedIndex].subAssemblies.length; i++) {
            let part = state.assemblies[state.selectedIndex].subAssemblies[i];
            if (searchPassSubAsm(part)) {
                parts.push(<SubAssembly colorInd={ind} index={i} key={i+part.partName}></SubAssembly>)
                ind++;
            }
        }
        return <RowsContainer height="80%">{parts}</RowsContainer>;
    }

    return <DataGrid height="72%">
        <SubAssemblysHeader></SubAssemblysHeader>
        {getData()}
    </DataGrid>
}
